import React from "react";
import { translate } from "application/functions";

const InfoAlert = ({ message, onClose }) => {
  return (
    <div className="info-overlay" onClick={onClose}>
      <div className="info-alert">
        <div className="info-alert-content">
          <p>{message}</p>
          <button className="close-button">{translate("close")}</button>
        </div>
      </div>
    </div>
  );
};

export default InfoAlert;
